module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0102.jpg?v=a777648e";